import { StyledSearchContainer } from 'components/Table/CommonSearch/styles'
import { Font14 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const HomeDevicesContainer = styled.div`
  padding-top: 16px;
  display: block;
`
export const HomeDevicesHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-bottom: 16px;
  @media ${theme.devices.tablet} {
    margin-bottom: 0;
  }
`
export const HomeDevicesTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
`
export const HomeDevicesFiltersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: start;
  gap: ${theme.spacing.xs};
  @media ${theme.devices.desktop} {
    align-items: center;
    flex-direction: row;
  }
`
export const HomeDevicesCount = styled.div`
  padding: 8px 16px;
  height: 32px;
  border-radius: 8px;
  background: ${theme.colors.white};
  display: flex;
  transition: all 0.3s ease;
  font-weight: normal;
  ${Font14};
  width: 93px;
`
export const HomeDevicesSelectorsWrapper = styled.div`
  display: grid;
  grid-template: 1fr 1fr 1fr 1fr / 100%;
  gap: 10px;
  @media ${theme.devices.tablet} {
    display: flex;
  }
  @media ${theme.devices.desktop} {
    grid-template: 100% / 1fr 1fr 1fr 1fr;
  }

  ${StyledSearchContainer} {
    z-index: unset;
  }
`

export const HomeDevicesRedioTileWrapper = styled.div`
  width: 100%;
  @media ${theme.devices.tablet} {
    width: 100%;
  }
  @media ${theme.devices.desktop} {
    width: 45%;
  }
`
